import { type TFunction } from "i18next";
import { match } from "ts-pattern";

export const ComptryxMeasure = {
  BASE_SALARY: "BASE_SALARY",
  ON_TARGET_TOTAL_CASH: "ON_TARGET_TOTAL_CASH",
  ACTUAL_TOTAL_CASH: "ACTUAL_TOTAL_CASH",
} as const;

export type ComptryxMeasure = (typeof ComptryxMeasure)[keyof typeof ComptryxMeasure];

export const formatComptryxMeasure = (t: TFunction, measure: ComptryxMeasure) => {
  return match(measure)
    .with(ComptryxMeasure.BASE_SALARY, () => t("pages.market-data.market-data-table.base-salary"))
    .with(ComptryxMeasure.ON_TARGET_TOTAL_CASH, () => t("pages.market-data.market-data-table.on-target-total-cash"))
    .with(ComptryxMeasure.ACTUAL_TOTAL_CASH, () => t("pages.market-data.market-data-table.actual-total-cash"))
    .exhaustive();
};

export const formatComptryxMeasureDescription = (t: TFunction, measure: ComptryxMeasure) => {
  return match(measure)
    .with(ComptryxMeasure.BASE_SALARY, () => t("components.measure.format-measure-description.base-salary"))
    .with(ComptryxMeasure.ON_TARGET_TOTAL_CASH, () =>
      t("pages.market-data.market-data-table.on-target-total-cash-description")
    )
    .with(ComptryxMeasure.ACTUAL_TOTAL_CASH, () =>
      t("pages.market-data.market-data-table.actual-total-cash-description")
    )
    .exhaustive();
};

export const convertComptryxMeasureToMeasure = (measure: ComptryxMeasure) => {
  return match<ComptryxMeasure, "baseSalary" | "totalCash">(measure)
    .with(ComptryxMeasure.BASE_SALARY, () => "baseSalary")
    .with(ComptryxMeasure.ON_TARGET_TOTAL_CASH, () => "totalCash")
    .with(ComptryxMeasure.ACTUAL_TOTAL_CASH, () => "totalCash")
    .exhaustive();
};
